import { atcb_action } from 'add-to-calendar-button-react'

export function addToCalendar({ name, date }: { name: string; date: string }) {
  atcb_action({
    name: `[Contester.life] ${name}`,
    startDate: `${date}`,
    options: ['Google'],
    timeZone: 'Asia/Bangkok',
  })
}
